import { useMutation } from '@tanstack/react-query'
import { queryClient } from 'src'
import { apiBase } from '~utils/base-url'
import { useFetch } from '~utils/fetch-request'

export function useDeletePortInfo() {
  const fetchRequest = useFetch()

  return useMutation({
    mutationFn: (portInfoId: string) =>
      fetchRequest(
        `${apiBase()}/portinfo/${portInfoId}`,
        undefined,
        undefined,
        'DELETE',
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['/portinfo'],
      })
    },
  })
}
